import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { UserDetailsService } from '../../services/user-details.service';
import { Utility } from '../../shared/utility/utility';
import { userCashLimitCheck } from '../../shared/utility/config';
import { EmitterService } from '../../services/emitter.service';
import { BannerService } from '../../services/banner.service';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import * as _ from 'underscore';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-game-subheader-banner',
  templateUrl: './game-subheader-banner.component.html',
  styleUrls: ['./game-subheader-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class GameSubheaderBannerComponent implements OnInit, OnDestroy {

  user;
  userCashBalance;
  banners;
  userCurrencyCode;
  userCurrencyLimit;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private utils: Utility,
    private userDetailsService: UserDetailsService,
    private emitterService:EmitterService,
    private bannerService:BannerService
  ) { }

  ngOnInit() {
    this.initialstep();
    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (status) {
        this.initialstep();
      }
    });
    this.userDetailsService.userCashBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(update => {
     if(this.user && this.user.userStatus !== "play")
        this.initialstep();
    })
    this.userDetailsService.userProfileUpdated$.pipe(takeUntil(this.destroy$)).subscribe(update => {
      this.initialstep();
    })
  }
  initialstep() {
    this.user = this.userDetailsService.getUserProfileDetails();
    this.userCashBalance = this.userDetailsService.getUserCashBalance();
    this.userCurrencyCode = this.userDetailsService.getUserCurrencyCode();
    this.setUserCurrencyLimit();
    this.loadbanner();
  }
  setUserCurrencyLimit() {
    userCashLimitCheck.forEach(currencyObj => {
      if (currencyObj.currencyCode === this.userCurrencyCode) {
        this.userCurrencyLimit = currencyObj.currencyLimit;
      }
    })
  }
  loadbanner(bannerZoneID?: String) {
    let self=this;
    bannerZoneID = !bannerZoneID ? '16' : bannerZoneID;
    let bannerRequest = { 'zoneId': bannerZoneID };
    if (this.utils.getAffliateId('affiliate')) {
      bannerRequest["affiliateId"] = this.utils.getAffliateId('affiliate');
    } 
    Promise.resolve(this.bannerService.getBanners(bannerRequest)).then(banners => {
      if (banners && banners.length > 0) {
        let bannerLen = banners.length;
        let bannersTest = banners;

        _.each(bannersTest, (banner, index) => {
          bannersTest[index].content = banner.content.replace(new RegExp('{{userFirstName}}', 'g'), this.user ? this.user.firstName.toLowerCase() : "");
          bannersTest[index].content = banner.content.replace(new RegExp('{{userLastName}}', 'g'), this.user ? this.user.lastName.toLowerCase() : "");
        });
        _.each(bannersTest, banner => {
          if (this.user && this.user.userStatus === "play") {
            this.banners = banner;
          } else if (this.userCashBalance < this.userCurrencyLimit && banner.category.includes("real_low_balance_user_dashboard")) {
            this.banners = banner;
          } else if (this.userCashBalance >= this.userCurrencyLimit && banner.category.includes("real_high_balance_user_dashboard")) {
            this.banners = banner;
          }
        });
        setTimeout(() => {
          let bannersButtons = $('.game-subheader-banner-deposit-now');
          $(bannersButtons).on('click', () => {
            self.emitterService.broadcastModalState({name:"paymentModal",state:"open",cashierType:"deposit"});
          });
        }, 1);
      } else {
        banners = banners;
      }
    });
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
